<template>
  <blockquote class="my-5 font-italic answer-text-quote">
    <span class="answer-text-quote-symbol">&bdquo;</span>
    <template v-if="showOnlyPreview">
      <v-tooltip
        open-on-hover
        bottom
        transition="none"
        max-width="500"
      >
        <template v-slot:activator="{ on, attrs }">
          <span v-on="on" v-bind="attrs" style="cursor: help;">
            {{ previewText }}
            <v-icon color="primary" style="display: inline;" small>mdi-dots-horizontal-circle</v-icon>
          </span>
        </template>
        <span>{{ text }}</span>
      </v-tooltip>
    </template>
    <template v-else>
      <span>{{ text }}</span>
      <span class="answer-text-quote-symbol">&rdquo;</span>
    </template>
  </blockquote>
</template>

<script>
export default {
  name: 'TextQuote',
  props: {
    text: {
      required: true
    },
    previewLength: {
      default: null
    }
  },

  computed: {
    showOnlyPreview () {
      return this.text && this.previewLength && this.text.length > this.previewLength;
    },

    previewText () {
      return this.text.substr(0, this.previewLength);
    }
  }
}
</script>

<style scoped>

</style>
